<template>
  <!-- MBR052 round header button (was a floating pill over the list); opens FilterTransaction -->
  <button
    type="button"
    class="mbr-filter-btn"
    :class="{ 'mbr-filter-btn--on': hasFilter }"
    :aria-label="$t('filter_transaction.title')"
    data-bs-toggle="modal"
    data-bs-target="#bottom_modal_filter"
  >
    <svg fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true">
      <path stroke-linecap="round" stroke-linejoin="round" d="M4 21v-7m0-4V3m8 18v-9m0-4V3m8 18v-5m0-4V3M1 14h6m2-6h6m2 8h6" />
    </svg>
    <span v-if="hasFilter" class="mbr-filter-btn__dot" aria-hidden="true"></span>
  </button>
</template>

<script>
export default {
  name: "filter-toobar",
  props: {
    id: {
      type: String,
      required: true,
    },
    filterArrCashbackEarnStatus: {
      type: Array,
    },
    filterArrStore: {
      type: Array,
    },
    filterCashbackTimeSelected: {
      type: Number,
    }
  },
  computed: {
    // same condition that used to show the green check on the pill
    hasFilter() {
      return !!(
        (this.filterArrCashbackEarnStatus && this.filterArrCashbackEarnStatus.length) ||
        (this.filterArrStore && this.filterArrStore.length) ||
        this.filterCashbackTimeSelected
      );
    },
  },
};
</script>
<style scoped>
.mbr-filter-btn {
  position: relative;
  display: flex;
  flex: none;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  padding: 0;
  background: var(--mbr-color-surface);
  border: 1px solid var(--mbr-color-outline);
  border-radius: var(--mbr-radius-full);
  color: var(--mbr-color-primary);
  box-shadow: 0 1px 2px rgba(var(--mbr-color-primary-rgb), 0.05);
  transition: transform 0.12s ease, border-color 0.15s ease;
}

.mbr-filter-btn:active {
  transform: scale(0.95);
}

.mbr-filter-btn:focus-visible {
  outline: 2px solid var(--mbr-color-primary);
  outline-offset: 2px;
}

.mbr-filter-btn svg {
  width: 16px;
  height: 16px;
}

.mbr-filter-btn--on {
  border-color: var(--mbr-color-primary);
}

.mbr-filter-btn__dot {
  position: absolute;
  top: 6px;
  right: 6px;
  width: 7px;
  height: 7px;
  background: var(--mbr-color-primary);
  border: 1.5px solid var(--mbr-color-surface);
  border-radius: var(--mbr-radius-full);
}
</style>
